// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__h68Q2","label":"styles_label__lMpXY","icon":"styles_icon___WSeH"};